import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function OrderPayment() {
  const [value, setValue] = React.useState("card");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <FormControl sx={{ marginLeft: "10px" }}>
      <FormLabel id="demo-controlled-radio-buttons-group">
        Payment Method
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value="card"
          control={<Radio />}
          label="Credit Card"
        />
        <FormControlLabel
          value="delivery"
          control={<Radio />}
          label="Pay on delivery"
        />
      </RadioGroup>
    </FormControl>
  );
}
